var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"eagle-form-item":"banner"}},[_c('bannerEditor',{attrs:{"disabled":_vm.disabled || _vm.readonly,"formDataItem":_vm.formDataItem},model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }